<template>
    <div class="modul-component">
        <div class="modul-body">
            <b-form data-vv-scope="modul-form">
                <b-form-group
                    label="Terbitkan ?"
                    label-for="published"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-radio-group
                        id="materi-publish"
                        name="materi_publish"
                        v-model="modul_form.is_publish"
                        :options="options"
                        class=""
                        value-field="item"
                        text-field="name"
                        disabled-field="notEnabled"
                    ></b-form-radio-group>
                    <span :class="{ 'error-validation': errors.first('materi-form.materi_publish') }">{{ errors.first('materi-form.materi_publish') }}</span>
                </b-form-group>
                <b-form-group
                    label="Nama"
                    label-for="nama"
                    label-cols-sm="4"
                    label-align-sm="left"
                >
                    <b-form-input
                        id="modul-name"
                        name="name"
                        data-vv-as="Nama"
                        v-model="modul_form.name"
                        type="text"
                        placeholder="Nama"
                        v-validate="'required'"
                        autocomplete="off"
                    ></b-form-input>
                    <span :class="{ 'error-validation': errors.first('modul-form.name') }">{{ errors.first('modul-form.name') }}</span>
                </b-form-group>
                <b-form-group
                    label="Tanggal Efektif"
                    label-for="effective_date"
                    label-cols-sm="4"
                    label-align-sm="left"
                >
                    <b-form-datepicker
                        id="effective-date"
                        v-model="modul_form.effective_date"
                        name="effective_date"
                        data-vv-as="Tanggal Efektif"
                        v-validate="'required'"
                        class="mb-2"
                    ></b-form-datepicker>
                    <span :class="{ 'error-validation': errors.first('modul-form.effective_date') }">{{ errors.first('modul-form.effective_date') }}</span>
                </b-form-group>
                <b-form-group
                    label="Urutan"
                    label-for="idx"
                    label-cols-sm="4"
                    label-align-sm="left"
                >
                    <b-form-input
                        id="idx"
                        name="idx"
                        data-vv-as="Urutan"
                        v-model="modul_form.idx"
                        type="text"
                        @keypress="isNumber($event)"
                        placeholder="Urutan"
                        v-validate="'required'"
                        autocomplete="off"
                    ></b-form-input>
                    <span :class="{ 'error-validation': errors.first('modul-form.idx') }">{{ errors.first('modul-form.idx') }}</span>
                </b-form-group>
                <b-form-group
                    label="Prasyarat"
                    label-for="prasyarat"
                    label-cols-sm="4"
                    label-align-sm="left"
                >
                    <b-form-select
                        v-model="modul_form.prasyarat"
                        name="prasyarat"
                        data-vv-as="Prasyarat"
                        :options="modulList"
                    ></b-form-select>
                    <span :class="{ 'error-validation': errors.first('modul-form.prasyarat') }">{{ errors.first('modul-form.prasyarat') }}</span>
                </b-form-group>
                <b-form-group
                    label="Nilai Materi"
                    label-for="nilai-materi"
                    label-cols-sm="4"
                    label-align-sm="left"
                >
                    <b-input-group append="%" class="mb-2 mr-sm-2 mb-sm-0">
                        <b-form-input
                            id="nilai_materi"
                            name="nilai_materi"
                            data-vv-as="Nilai materi"
                            v-model="modul_form.nilai_materi"
                            type="text"
                            @keypress="isNumber($event)"
                            placeholder="Nilai Materi"
                            v-validate="'required|max_value:100'"
                            autocomplete="off"
                        ></b-form-input>
                    </b-input-group>
                    <span :class="{ 'error-validation': errors.first('modul-form.nilai_materi') }">{{ errors.first('modul-form.nilai_materi') }}</span>
                </b-form-group>
                <b-form-group
                    label="Nilai Tugas"
                    label-for="nilai-tugas"
                    label-cols-sm="4"
                    label-align-sm="left"
                >
                    <b-input-group append="%" class="mb-2 mr-sm-2 mb-sm-0">
                        <b-form-input
                            id="nilai_tugas"
                            name="nilai_tugas"
                            data-vv-as="Nilai tugas"
                            v-model="modul_form.nilai_tugas"
                            type="text"
                            @keypress="isNumber($event)"
                            placeholder="Nilai Tugas"
                            v-validate="'required|max_value:100'"
                            autocomplete="off"
                        ></b-form-input>
                    </b-input-group>
                    <span :class="{ 'error-validation': errors.first('modul-form.nilai_tugas') }">{{ errors.first('modul-form.nilai_tugas') }}</span>
                </b-form-group>
                <b-form-group
                    label="Nilai Evaluasi"
                    label-for="nilai-evaluasi"
                    label-cols-sm="4"
                    label-align-sm="left"
                >
                    <b-input-group append="%" class="mb-2 mr-sm-2 mb-sm-0">
                        <b-form-input
                            id="nilai_evaluasi"
                            name="nilai_evaluasi"
                            data-vv-as="Nilai evaluasi"
                            v-model="modul_form.nilai_evaluasi"
                            type="text"
                            @keypress="isNumber($event)"
                            placeholder="Nilai Evaluasi"
                            v-validate="'required|max_value:100'"
                            autocomplete="off"
                        ></b-form-input>
                    </b-input-group>
                    <span :class="{ 'error-validation': errors.first('modul-form.nilai_evaluasi') }">{{ errors.first('modul-form.nilai_evaluasi') }}</span>
                </b-form-group>
                <b-form-group
                    label="Nilai Ketuntasan Modul"
                    label-for="nilai-minimum"
                    label-cols-sm="4"
                    label-align-sm="left"
                >
                    <b-form-input
                        id="nilai_minimum"
                        name="nilai_minimum"
                        data-vv-as="Nilai Ketuntasan Modul"
                        v-model="modul_form.nilai_minimum"
                        type="text"
                        @keypress="isNumber($event)"
                        placeholder="Nilai Ketuntasan Modul"
                        v-validate="'required'"
                        autocomplete="off"
                    ></b-form-input>
                    <span :class="{ 'error-validation': errors.first('modul-form.nilai_minimum') }">{{ errors.first('modul-form.nilai_minimum') }}</span>
                </b-form-group>
                <b-form-group
                    label="Tanggal Mulai"
                    label-for="start_date"
                    label-cols-sm="4"
                    label-align-sm="left"
                >
                    <b-form-datepicker
                        id="start-date"
                        v-model="modul_form.start_date"
                        name="start_date"
                        data-vv-as="Tanggal Mulai"
                        v-validate="'required'"
                        class="mb-2"
                    ></b-form-datepicker>
                    <span :class="{ 'error-validation': errors.first('modul-form.start_date') }">{{ errors.first('modul-form.start_date') }}</span>
                </b-form-group>
                <b-form-group
                    label="Tanggal Berakhir"
                    label-for="end_date"
                    label-cols-sm="4"
                    label-align-sm="left"
                >
                    <b-form-datepicker
                        id="end-date"
                        v-model="modul_form.end_date"
                        name="end_date"
                        data-vv-as="Tanggal Berakhir"
                        v-validate="'required'"
                        class="mb-2"
                    ></b-form-datepicker>
                    <span :class="{ 'error-validation': errors.first('modul-form.end_date') }">{{ errors.first('modul-form.end_date') }}</span>
                </b-form-group>
            </b-form>
        </div>
        <hr>
        <div class="new-class-footer d-flex justify-content-end">
            <square-loader :loading="showLoader" :color="'#ca062a'" :size="'30px'"></square-loader>
            <b-button v-if="!showLoader" variant="outline-danger" size="md" style="width: 25%;" @click="hideModulFormModal">BATAL</b-button>
            <b-button v-if="!showLoader" variant="primary" size="md" style="width: 25%;" @click.prevent="saveModul">SIMPAN</b-button>
        </div>
    </div>
</template>

<script>
    import { EventBus } from '@/eventBus.js'
    import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
    export default {
        props: {
            subjectId: {
                type: String,
                default: null
            },
            modulId: {
                type: String,
                default: null
            },
            modulList: {
                type: Array,
                default () {
                    return [{}]
                }
            },
            modulDetail: {
                type: Object,
                default () {
                    return {}
                }
            }
        },
        components: {
            SquareLoader
        },
        data() {
            return {
                showLoader: false,
                modul_form: {
                    is_publish: this.modulId ? this.modulDetail.is_publish : 1,
                    subjects_id : this.subjectId,
                    name : this.modulId ? this.modulDetail.name: null,
                    effective_date : this.modulId ? this.modulDetail.effective_date: null,
                    idx : this.modulId ? this.modulDetail.idx: null,
                    prasyarat : this.modulId ? this.modulDetail.prasyarat: null,
                    nilai_materi : this.modulId ? this.modulDetail.nilai_materi: null,
                    nilai_tugas : this.modulId ? this.modulDetail.nilai_tugas: null,
                    nilai_evaluasi : this.modulId ? this.modulDetail.nilai_evaluasi: null,
                    nilai_minimum : this.modulId ? this.modulDetail.nilai_minimum: null,
                    start_date : this.modulId ? this.modulDetail.start_date: null,
                    end_date : this.modulId ? this.modulDetail.end_date: null,
                },
                options: [
                    { item: '1', name: 'Ya' },
                    { item: '0', name: 'Tidak' },
                ],
            };
        },
        methods: {
            resetModulForm() {
                this.modul_form.subjects_id = this.subjectId,
                this.modul_form.is_publish = this.modulId ? this.modulDetail.is_publish : 1,
                this.modul_form.name = this.modulId ? this.modulDetail.name : null,
                this.modul_form.effective_date = this.modulId ? this.modulDetail.effective_date : null,
                this.modul_form.idx = this.modulId ? this.modulDetail.idx : null,
                this.modul_form.prasyarat = this.modulId ? this.modulDetail.prasyarat : null,
                this.modul_form.nilai_materi = this.modulId ? this.modulDetail.nilai_materi : null,
                this.modul_form.nilai_tugas = this.modulId ? this.modulDetail.nilai_tugas : null,
                this.modul_form.nilai_evaluasi = this.modulId ? this.modulDetail.nilai_evaluasi : null,
                this.modul_form.nilai_minimum = this.modulId ? this.modulDetail.nilai_minimum : null,
                this.modul_form.start_date = this.taskId ? this.taskDetail.start_date : null
                this.modul_form.end_date = this.taskId ? this.taskDetail.end_date : null
                this.$validator.reset()
            },
            hideModulFormModal() {
                EventBus.$emit('hideModulFormModal', true)
                this.resetModulForm()
            },
            async saveModul() {
                let scope = 'modul-form'
                this.$validator.validateAll(scope).then(valid => {
                    if (valid) {
                        if (this.modulId) {
                            this.modul_form.id = this.modulId
                            this.updateModul(scope)
                        } else {
                            this.addModul(scope)
                        }
                    }
                });
            },
            async updateModul(scope) {
                this.showLoader = true
                let form = this.modul_form
                this.$store.dispatch('updateModul', form)
                    .then((res) => {
                        this.showLoader = false
                        let subjectId = this.subjectId
                        this.$store.dispatch('getSubjectDetail', { subjectId })
                        this.hideModulFormModal()
                        this.$swal.fire('Success', res.message, 'success')
                    })
                    .catch((err)=> {
                        let error = err.response
                        this.showLoader = false
                        if (error.status == 400) {
                            this.errorValidate(error.data, scope)
                        } else {
                            this.$swal.fire('Failed', error.data.message, 'error')
                        }
                    })
            },
            async addModul(scope) {
                this.showLoader = true
                let form = this.modul_form
                this.$store.dispatch('addModul', form)
                    .then((res) => {
                        this.showLoader = false
                        let subjectId = this.subjectId
                        this.$store.dispatch('getSubjectDetail', { subjectId })
                        this.hideModulFormModal()
                        this.$swal.fire('Success', res.message, 'success')
                    })
                    .catch((err)=> {
                        let error = err.response
                        this.showLoader = false
                        if (error.status == 400) {
                            this.errorValidate(error.data, scope)
                        } else {
                            this.$swal.fire('Failed', error.data.message, 'error')
                        }
                    })
            }
        },
		created () {
			EventBus.$on('resetModulForm', (val) => {
				if (val) {
					this.resetModulForm()
				}
			})
        }
    }
</script>